// extracted by mini-css-extract-plugin
module.exports = {"container":"snapshot_title__container__Lhzqa"};